<template>
    <div class="home">
        <div class="user-line">
            <div class="system-title">南宁长租公寓内部员工系统</div>
            <div class="user" @click="userButtonGroup=!userButtonGroup">
                <div class="user-logo">
                    <img src="@/assets/images/logo_user.png" alt="">
                </div>
                <div class="user-text">{{ userInfo.username }}</div>
                <div class="dropdown-content" v-show="userButtonGroup" @click="exit"> 退出登录 </div>
            </div>
        
        </div>
        <div class="menu-box">
            <div class="menu-box-item" v-for="(item) in menuList" :key="item.name" @click="nav(item)">
                   <div class="item-img"><img :src="item.img" alt=""> </div>
                <!-- <div class="item-img"><img :src="getImagePath(item.img)" alt=""> </div> -->
                <div class="item-text">{{ item.name }}</div>
            </div>
        </div>
       

    </div>
  
</template>

<script>
import { mapState } from 'vuex';
export default {
    name:"home",
    created(){
         console.log('🔍 this.menuData 的值是：', this.menuData); // ⚠️ 重点！打印它！
        this.initializeData()
    },
    data() {
        return {
            menuList:[
                // {name:"办公管理",img:require("@/assets/images/home/bggl.png"),url:"/bggl"},
                // {name:"erp管理",img:require("@/assets/images/home/erp.png"),url:"/erp"},
                // {name:"绩效管理",img:require("@/assets/images/home/jxgl.png"),url:"/jxgl"},
                // {name:"系统设置",img:require("@/assets/images/home/xtgl.png"),url:"/xtpz"},
                // {name:"维修单填写",img:require("@/assets/images/home/wx_1.png"),url:"/tools/repair"},
            ],
            userButtonGroup:false,//用户操作按钮
        }
    },
    computed: {
        ...mapState(['menuData', 'userInfo'])
    },
    mounted(){console.log("userInfo==",this.userInfo)},
   

    watch:{},
    methods:{
        initializeData() {
            // 将 menuData 赋值给 data 中的 menuList 
            this.menuList = this.menuData;

            // 检查 userInfo
            if (!this.userInfo || Object.keys(this.userInfo).length === 0) {
                this.$Message.error("未检测到用户信息，返回登录页");
                this.$router.push('/login'); // 跳转到登录页面
            } else {
                this.$Message.success(`欢迎您【${this.userInfo.username}】`);
            }
        },
        // 加载图片
        getImagePath(imagePath) {
            console.log(imagePath)
            try {
             
                return require(`@/assets/images/home/${imagePath.split('/').pop()}`);
            } catch (error) {
                console.error('Image not found:', error);
                return '';
            }
        },
        exit(){
            this.$Modal.confirm({
                title:"退出登录提醒",
                content:"确认要退出登录吗？",
                onOk:()=>{
                    this.$store.commit('clearUserInfo'); // 调用 Vuex mutation
                    this.$store.commit('clearToken'); // 调用 Vuex mutation
                    this.$router.replace('/login'); // 跳转到登录页面
                }
            })
        },
        nav(item){
            // 
           if(item.name=="收房管理"||item.name=="出房管理"||item.name=="收/付款计划"){
                this.$router.push(item.url);
           }
        //    else if(item.name=="旧版本入口"){
        //     window.open(item.url, '_blank');
        //    }
           else{
                this.$Message.info("开发中，敬请期待.......")
           }
        }
    }
}
</script>

<style lang="scss">
@import 'home.scss'
</style>